import { parseDate } from "./parseDate";

export const formatDate = (date: Date) => date.toLocaleString();

// if date comes without Z in the end, it will be converted to UTC
export const convertToISO = (timestamp: string | number): string => {
  return parseDate(timestamp).toISOString();
};
